export const GRAPHQLserver = 'wss://www.school-in-motion.de/graphql'
